<template>
  <b-modal
    class="EmailVerificationModalClass"
    id="emailVerificationModal"
    title="Email Verification"
    ok-only
    ok-variant="secondary"
    hide-footer
    ref="showEmailVerificationModal"
    no-close-on-backdrop
  >
    <div class="row">
      <div class="col-sm-12">
        <label>Please enter your email</label>
        <input class="form-control" v-model="email" placeholder="name@mail.com" />
      </div>
      <div class="col-sm-3">
        <el-button type="primary" v-on:click="verifyEmail()">Verify Email address</el-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import DataSource from '../../../data/datasource'

export default {
  data() {
    return {
      code: '',
      email: '',
    }
  },
  methods: {
    async verifyEmail() {
      try {
        await this.$vs.loading()
        if (!this.email) {
          return this.$notify.error({
            title: 'Error',
            message: 'Verification email require.',
          })
        }
        const id = decodeURI(this.$route.query.ID)
        const res = await DataSource.shared.verifyEmailForApplicationForm(this.email, id)
        const code = Number(res?.code || 0)
        if (code !== 1 || !res?.applicationFormId) {
          return this.$notify.error({
            title: 'Error',
            message: res?.message || 'Unknown Error.',
          })
        }
        this.$emit('verify', res.applicationFormId)
        this.$bvModal.hide('emailVerificationModal')
      } finally {
        await this.$vs.loading.close()
      }
    },
  },
}
</script>
